/**
 * Interface que define todas as Feature Flags disponíveis no app Stock
 * 
 * Para adicionar uma nova flag:
 * 1. Adicione a propriedade aqui com tipo boolean
 * 2. Configure a flag no Firebase Remote Config
 * 3. Use via FeatureFlagsService.isEnabled('nomeDaFlag')
 */
export interface FeatureFlags {
    stockFeatureTest: boolean;
}

/**
 * Valores padrão para as flags caso o Firebase não esteja disponível
 * ou ocorra algum erro no carregamento
 */
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  stockFeatureTest: false,
};
